<script lang="ts">
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import "swiper/css";
  import MediaCoveragePostCard from "../cards/MediaCoveragePostCard.svelte";
  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor, IconType } from "$types/atoms";

  export let posts: any;

  let slider;
  let isBeginning = true;
  let isEnd = false;

  function swiperReady(e) {
    slider = e.detail[0];
    isBeginning = slider?.isBeginning;
    isEnd = slider?.isEnd;
  }

  function slidePrev() {
    slider.slidePrev();
    isBeginning = slider?.isBeginning;
    isEnd = slider?.isEnd;
  }

  function slideNext() {
    slider.slideNext();
    isBeginning = slider?.isBeginning;
    isEnd = slider?.isEnd;
  }
</script>

{#if posts}
  <Swiper
    on:swiper={swiperReady}
    navigation
    breakpoints={{
      0: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    }}
    spaceBetween={24}
    slidesPerView={3}
    class="!overflow-visible"
  >
    {#each posts as post}
      <SwiperSlide><MediaCoveragePostCard {post} /></SwiperSlide>
    {/each}
  </Swiper>

  <div class="flex gap-2.5 justify-end mt-[50px]">
    <Button
      icon={IconType.ARROW_LEFT_LARGE}
      color={ButtonColor.GRAY}
      reduced
      on:click={slidePrev}
      iconLeft={false}
    />
    <Button
      icon={IconType.ARROW_RIGHT_LARGE}
      color={ButtonColor.GRAY}
      reduced
      on:click={slideNext}
    />
  </div>
{/if}
